import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveProducts } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl, Maki, ContentrArea } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { Link } from 'react-router-dom';
import FilteredMasonry from './FilteredMasonry';

const ProductListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveProducts();
  }, [language]);

  return (
    <article>
      <Container className="list-page mb-5">
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="product-listing-page" />
        </Helmet>

        <h1 className="text-md-center mb-5 pagetitle">PRODUKTE</h1>

        <Container className="listing-filter-buttons-container">
          <Row className="mb-5 d-flex justify-items-center justify-content-center listing-buttons-container">
            <Col className="mt-3">
              <Link to="/tickets" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100">
                {'TICKETS'}
              </Link>
            </Col>
            <Col className="mt-3">
              <Link to="/products" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100 active">
                {'MERCHANDISE'}
              </Link>
            </Col>
            <Col className="mt-3">
              <Link to="/reissues" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100">
                {'VINYL RE-ISSUES'}
              </Link>
            </Col>
          </Row>
        </Container>

        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show products
          <Masonry
            id="product-listing"
            products={products.filter((p) => !p.tag_ids.includes(5))}
            columnClassName="col-sm-12 col-md-6 col-lg-6"
            filters="off"
            type={Maki}
            showFormerPrice
            // showTags
            showSubtitle
          />
        )}
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products, loading } = state.Products;
  return {
    products,
    loading,
  };
};

const mapDispatchToProps = {
  receiveProducts,
};

export default React.memo(ProductListing);
